import axios from "axios";

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");
const trimLeadingSlash = (value: string) => value.replace(/^\/+/, "");

export const apiBaseUrl = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3001"
);

export const apiUrl = (path: string) =>
  `${apiBaseUrl}/${trimLeadingSlash(path)}`;

export const getCurrentStudentNameMask = async (
  schoolId: number,
  coachId?: number
): Promise<boolean> => {
  const response = await axios.get(apiUrl("api/coach-config/current"), {
    params: coachId === undefined ? { schoolId } : { schoolId, coachId },
    withCredentials: true,
  });
  return Boolean(response.data?.data?.is_mask_student_name);
};

export const configureApiClient = () => {
  axios.defaults.baseURL = apiBaseUrl;
  axios.defaults.withCredentials = true;
};




// WEBPACK FOOTER //
// ./src/api/client.ts